(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[560],{

/***/ 55297:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/[slug]",
      function () {
        return __webpack_require__(7384);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var api_tracking__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5123);
/* harmony import */ var components_jobs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49339);
/* harmony import */ var components_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22821);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);





var SeoJobListPage = function(param) {
    var jobs = param.jobs, promotedJobs = param.promotedJobs, searchSummary = param.searchSummary, jobsFilter = param.jobsFilter, seoLink = param.seoLink;
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        api_tracking__WEBPACK_IMPORTED_MODULE_1__/* .TrackingAPI.jobBoardViewed */ .A.jobBoardViewed();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_seo__WEBPACK_IMPORTED_MODULE_3__/* .MetaTags */ .N, {
                title: "Jobs"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_jobs__WEBPACK_IMPORTED_MODULE_2__/* .JobList */ .n, {
                jobs: jobs,
                promotedJobs: promotedJobs,
                searchSummary: searchSummary,
                jobsFilter: jobsFilter,
                seoLink: seoLink
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (SeoJobListPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9339,9774,2888,179], function() { return __webpack_exec__(55297); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);